module.exports = __webpack_public_path__ + "static/img/bx_gif.9d24db91.gif";